import { render, staticRenderFns } from "./RequestPending.vue?vue&type=template&id=2a1c3380"
import script from "./RequestPending.vue?vue&type=script&lang=js"
export * from "./RequestPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports